import BackIcon from 'assets/images/rectangle/Back_black.svg'
import { useNavigate, useParams } from 'react-router-dom'
import { Dropdown } from 'react-bootstrap'
import CustomDropDown from 'components/dropDown'
import { useState } from 'react'
import CustomBottomSheet from 'components/bottomSheet'
import Share from '../share'
import JoinLink from '../joinLink'
interface IHeaderProps {
    exist: number
    hamyanBalance: number
    bankBalance: string
    inprogress: number
    balance: number
    showBalance: boolean
    poolShipId: number | undefined
    role: string
    setIsOpenExcelModal: React.Dispatch<React.SetStateAction<boolean>>
    isFuckingManager: () => boolean
    name: string
    servicePackage: number
    trustedState: string
}
export default function Header({
    exist,
    hamyanBalance,
    bankBalance,
    inprogress,
    balance,
    showBalance,
    poolShipId,
    role,
    name,
    isFuckingManager,
    setIsOpenExcelModal,
    servicePackage,
    trustedState,
}: IHeaderProps) {
    const [shareBottomSheet, setShareBottomSheet] = useState<boolean>(false)
    const [joinLinkBottomSheet, setJoinLinkBottomSheet] =
        useState<boolean>(false)
    const navigate = useNavigate()
    const { id } = useParams()

    return (
        <>
            {/* Toolbar — ?actionBarSize (56px) white bar with 1px bottom hairline */}
            <div className="relative h-14 w-full bg-white border-b border-[#EFEFEF]">
                {/* Package badge (yellow CardView, 15dp radius, pulled up -15dp) */}
                <div className="absolute -top-[15px] right-[64px] z-10">
                    <div className="w-[50px] rounded-[15px] bg-[#FFCC00] shadow-badge px-2 pt-5 pb-2.5">
                        <p className="text-center text-[10px] text-black">
                            {servicePackage === 1
                                ? 'اشتراکی'
                                : servicePackage === 2
                                ? 'رایگان'
                                : 'کارمزدی'}
                        </p>
                    </div>
                </div>

                {/* Trust-state badge (green CardView, 15dp radius, pulled up -15dp) */}
                {servicePackage !== 2 && (
                    <div className="absolute -top-[15px] left-[66px] z-10">
                        <div className="w-[60px] rounded-[15px] bg-green-1 shadow-badge px-2 pt-[18px] pb-1.5">
                            <p className="text-center text-[10px] text-white leading-tight">
                                {trustedState === 'trst'
                                    ? 'متصل به حساب همیان'
                                    : 'متصل به حساب مدیر'}
                            </p>
                        </div>
                    </div>
                )}

                {/* Center: title + balance dropdown */}
                {showBalance && (
                    <div className="absolute inset-0 flex flex-col items-center justify-center">
                        <p className="text-[12px] text-black leading-none">
                            موجودی صندوق
                        </p>
                        <Dropdown>
                            <Dropdown.Toggle
                                style={{
                                    backgroundColor: 'transparent',
                                    border: 'none',
                                    boxShadow: 'none',
                                    padding: '0px',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <span className="flex items-center gap-1 text-[16px] font-bold text-black">
                                    <svg
                                        className="w-3 h-3"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    >
                                        <polyline points="6 9 12 15 18 9" />
                                    </svg>
                                    {exist && exist.toLocaleString()} تومان
                                </span>
                            </Dropdown.Toggle>
                            <Dropdown.Menu
                                style={{
                                    backgroundColor: '#D3E8EB',
                                    padding: '10px',
                                    width: '230px',
                                    border: 'none',
                                }}
                                id="dropdown-center"
                            >
                                <p className="text-center my-1">
                                    موجودی نزد همیان:
                                </p>
                                <p className="text-center my-1">
                                    {' '}
                                    {hamyanBalance &&
                                        hamyanBalance.toLocaleString()}{' '}
                                    <span>تومان</span>
                                </p>
                                <p className="text-center my-1">
                                    موجودی نزد مدیر:
                                </p>
                                <p className="text-center my-1">
                                    {bankBalance &&
                                        Number(bankBalance).toLocaleString()}{' '}
                                    تومان
                                </p>
                                <p className="text-center my-1">
                                    درحال واریز به حساب صندوق:
                                </p>
                                <p className="text-center my-1">
                                    {inprogress &&
                                        Number(inprogress).toLocaleString()}{' '}
                                    تومان
                                </p>
                                <p className="text-center my-1">مجموع موجودی:</p>
                                <p className="text-center my-1">
                                    {balance &&
                                        Number(balance).toLocaleString()}{' '}
                                    تومان
                                </p>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                )}

                {/* Back button — 16dp, far right, vertically centered, marginRight 14dp */}
                <img
                    src={BackIcon}
                    alt="back-icon"
                    onClick={() => navigate(-1)}
                    className="absolute right-[14px] top-1/2 -translate-y-1/2 w-4 h-4 cursor-pointer"
                />

                {/* Options menu — far left (settings slot) */}
                <div className="absolute left-2 top-1/2 -translate-y-1/2">
                    <CustomDropDown listWrapperClassName="w-[188px] top-4 absolute">
                        <div className="text-sm text-right px-2">
                            {isFuckingManager() && (
                                <>
                                    <p
                                        className="my-2"
                                        onClick={() =>
                                            navigate(`/fund/plans/${id}`, {
                                                state: {
                                                    name,
                                                    servicePackage,
                                                },
                                            })
                                        }
                                    >
                                        خرید اشتراک
                                    </p>
                                    <p
                                        className="my-2"
                                        onClick={() =>
                                            setIsOpenExcelModal(true)
                                        }
                                    >
                                        دریافت اکسل گزارش صندوق
                                    </p>
                                    <p
                                        className="my-2"
                                        onClick={() =>
                                            navigate(
                                                `/fund/financial-dashboard/${id}`,
                                                { state: { name } }
                                            )
                                        }
                                    >
                                        داشبورد هزینه و درآمد
                                    </p>
                                    <p
                                        className="my-2"
                                        onClick={() =>
                                            setShareBottomSheet(true)
                                        }
                                    >
                                        لینک پرداخت صندوق
                                    </p>
                                    <p
                                        className="my-2"
                                        onClick={() =>
                                            navigate(`/fund/setting/${id}`)
                                        }
                                    >
                                        تنظیمات صندوق
                                    </p>
                                    <p
                                        className="my-2"
                                        onClick={() =>
                                            setJoinLinkBottomSheet(true)
                                        }
                                    >
                                        لینک عضویت در صندوق
                                    </p>
                                </>
                            )}
                            <p
                                className="my-2"
                                onClick={() => {
                                    isFuckingManager()
                                        ? navigate(
                                              `/fund/admin-settlement-exit/${id}`
                                          )
                                        : navigate(
                                              `/fund/settlement-exit/${id}`,
                                              { state: { poolShipId } }
                                          )
                                }}
                            >
                                {isFuckingManager()
                                    ? 'درخواست های تسویه و خروج'
                                    : 'درخواست تسویه و خروج'}
                            </p>
                        </div>
                    </CustomDropDown>
                </div>
            </div>
            <CustomBottomSheet
                isOpen={shareBottomSheet}
                onDismiss={() => setShareBottomSheet(false)}
            >
                <Share />
            </CustomBottomSheet>
            <CustomBottomSheet
                isOpen={joinLinkBottomSheet}
                onDismiss={() => setJoinLinkBottomSheet(false)}
            >
                <JoinLink />
            </CustomBottomSheet>
        </>
    )
}
